import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useDocumentTitle } from './useDocumentTitle';
import { useAppLogo } from './useAppLogo';
import { useFavicon } from './useFavicon';

/** Sets document title and favicon from env app name + logo settings. */
export function useAppBranding() {
  useDocumentTitle();
  const { isAuthenticated } = useAuth();
  const logo = useAppLogo(isAuthenticated);
  useFavicon(logo?.logoUrl || logo?.logoPath);
}

export const AppBrandingHead: React.FC = () => {
  useAppBranding();
  return null;
};
